import { responseStartGame } from "../../classes/types/class-user.types";

async function sendGetGameStartedRequest(userId: string): Promise<boolean> {
    try {
        const response: Response = await fetch(`${viteConfiguration.API_URL}user/game/checkprogress`, {
            method: "post",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({ userId }),
        });

        const result: responseStartGame = await response.json();

        if (!result.data) {
            return false;
        }

        const gameStatus: number = result.data[0].game_started;

        if (gameStatus === 1) {
            return true;
        }

        return false;
    } catch (error) {
        console.error(error);
    }
    return false;
}

export default sendGetGameStartedRequest;
